import type { TAppointment } from './appointment';
import type { TCalendlyType } from './calendly-types';
import type { TCustomField } from './custom-field';
import type { TLabel } from './label';
import type { TLeadReferal } from './lead-referal';
import type { TLeadStatus } from './lead-status';
import type { TMember, TMemberMini } from './member';
import type { GENDER, LANGUAGE_LEVEL } from './placement';
import type { TOrganization } from './organization';
import type { TProgramWithSubmission } from './program';
import type { TStudentMini } from './student';
import type { TUser } from './user';
import type { ValueOf } from './utilities';
import type { TImportHistory } from './import-histories';
import { TUniversity } from '@src/features/universities/types';
import type { TPartner } from '@src/features/users/services/partners-api';

export const LEAD_RANK = {
  hot: 'HOT',
  warm: 'WARM',
  cold: 'COLD',
} as const;

export const LEAD_SOURCE = {
  calendly: 'CALENDLY',
  website: 'WEBSITE',
  advertisement: 'ADVERTISEMENT',
  wordOfMouth: 'WORD_OF_MOUTH',
  employeeReferrel: 'EMPLOYEE_REFERREL',
  coldCall: 'COLD_CALL',
  customerReferrel: 'CUSTOMER_REFERREl',
  other: 'OTHER',
} as const;

export type TLead = {
  id: number;
  university: TUniversity;
  sharable_uid: number;
  formatted_sharable_uid: string;
  import_history: TImportHistory;
  organization: TOrganization;
  student: TUser;
  db_student: TStudentMini;
  assignee: TUser;
  assigned_member: TMemberMini;
  labels: TLabel[];
  custom_fields: TCustomField[];

  phone_number: string;
  partner?: TPartner | null;

  programs: TProgramWithSubmission[];
  calendly_event_type: TCalendlyType;
  status?: TLeadStatus;
  referal?: TLeadReferal;
  meetings: TAppointment[];
  duplicate_email: boolean;
  duplicate_phone: boolean;

  name: string;
  email: string;
  whatsapp_number: string;
  birth_date: string;
  source_note: string;
  has_meeting_notes: boolean;
  is_manual: boolean;
  is_archived: boolean;
  /** Member id of who archived the lead — present when `is_archived` is true. */
  archived_by?: number | null;
  /** When the lead was archived (ISO). */
  archived_at?: string | null;
  has_notes: boolean;

  gender: ValueOf<typeof GENDER>;
  english_level: ValueOf<typeof LANGUAGE_LEVEL>;
  source: ValueOf<typeof LEAD_SOURCE>;
  rank: ValueOf<typeof LEAD_RANK>;

  metadata: { position: number; question: string; answer: string }[] | null;
  main_info: string;
  next_follow_up_date: string;
  created_by: TUser;
  creator_member: TMember;

  created_at: string;
  updated_at: string;

  screening_meeting_date: string;
  screening_meeting_id: number;
};
